<template>
  <b-card header="Browse Evidence" no-body>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <b-card class="p-3" v-if="loaded">
      <div class="row">
        <div v-for="gallery in galleries" :key="gallery.id" class="col-6 col-md-4 col-xl-2 ">
          <router-link :to="'/evidence_gallery/' + gallery.id" class="border pointer card">
            <b-card-header>
              {{ gallery.project_name | truncate(15) }}
            </b-card-header>
            <b-card-body>
              <b-img-lazy :src="gallery.preview.url" fluid v-if="gallery.preview"></b-img-lazy>
              <b-img blank fluid width="400" height="400" blank-color="#777" v-if="!gallery.preview"/>
            </b-card-body>
          </router-link>
        </div>
      </div>
    </b-card>
  </b-card>
</template>

<script>
export default {
  name: 'EvidenceGalleryBrowse',
  data () {
    return {
      loaded: false,
      galleries: []
    };
  },
  methods: {},
  mounted () {
    this.axios.get('/evidence_gallery').then(rsp => {
      this.galleries = rsp.data.data;
      this.loaded = true;
    });
  }
};
</script>
